export const STATUS_RECONCILIATION_POPUP_CONSTANTS = {
    PROJECT_CLOSED_WON_ERROR_MSG: 'A closed won project needs to contain at least one Won quote and cannot contain any In-progress quotes.',
    PROJECT_CLOSED_LOST_ERROR_MSG: 'A closed lost project cannot contain any Won or In-progress quotes.',
    PROJECT_CLOSED_ABANDONED_ERROR_MSG: 'A no bid project cannot contain any Won or In-progress quotes.',
    DEFAULT_COL_DEFS: {
        flex: 1,
        sortable: false,
        unSortIcon: false,
        menuTabs: [],
        resizable: true,
        suppressFillHandle: true,
        suppressMovable: true,
        filter: false,
        suppressMenu: true
    },
    MODAL_TITLE: 'Stage & Statuses Reconciliation',
    MODAL_DESCRIPTION: 'Take a moment to adjust project stage and quotes statuses for this project, this is critical in maintaining quality data used for reporting.',
    LINK_TITLE: 'For more information about status changes and best practices,',
    LINK_URL: 'https://knowledgebase.parspec.io/knowledge/update-project-stage-and-bom-status',
    LINK_TEXT: 'learn more',
    BUTTON_TAGS: {
        WON: 'Won',
        LOST: 'Lost',
        ABANDONED: 'Abandoned'
    },
    PROJECT_STAGE_REBID: 'Rebid',
    PROJECT_STAGE_CLOSED_LOST: 'Closed Lost',
    PROJECT_STAGE_NO_BID: 'No Bid',
    PROJECT_STAGE_CLOSED_WON: 'Closed Won',
    BULK_ACTION_BUTTON_TOOL_TIP_MSG: 'Select Item(s) first'
};
